import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch() {
    console.error('Application rendering failed.');
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-4">
              <span className="text-destructive text-xl font-bold">!</span>
            </div>
            <h2 className="font-grotesk text-lg font-semibold mb-2">Something went wrong</h2>
            <p className="font-inter text-sm text-muted-foreground mb-4">
              This page could not be loaded. Reload it to try again.
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              className="px-4 py-2 bg-teal text-white rounded-lg font-inter text-sm hover:bg-teal/90 transition-colors"
              data-testid="error-boundary-reload"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
